import { Colors } from '..';
import generateGradient from './generateGradient';

const orange = {
  conical: generateGradient(
    [Colors.Orange[600], Colors.Orange[25]],
    'conical',
    {},
    {
      originDeg: 259.08,
      originX: 50,
      originY: 50,
      deg: [0, 360],
    }
  ),
  linear01: generateGradient(
    [Colors.Orange[600], Colors.Orange[500]],
    'linear',
    {
      originDeg: 90,
      percent: [0, 100],
    }
  ),
  linear02: generateGradient(
    [Colors.Orange[700], Colors.Orange[600]],
    'linear',
    {
      originDeg: 45,
      percent: [0, 100],
    }
  ),
  linear03: generateGradient(
    [Colors.Orange[800], Colors.Orange[600]],
    'linear',
    {
      originDeg: 45,
      percent: [0, 100],
    }
  ),
  linear04: generateGradient(
    [Colors.Orange[800], Colors.Orange[600]],
    'linear',
    {
      originDeg: 90,
      percent: [0, 100],
    }
  ),
  linear05: generateGradient(
    [Colors.Orange[800], Colors.Orange[700]],
    'linear',
    {
      originDeg: 26.5,
      percent: [0, 100],
    }
  ),
  linear06: generateGradient(
    [Colors.Orange[900], Colors.Orange[600]],
    'linear',
    {
      originDeg: 45,
      percent: [0, 100],
    }
  ),
} as const;

export default orange;
